export default __webpack_public_path__ + "static/media/girl1.038c5a58.png";